<div style="margin: 0 auto; width: 100%">
    <div class="code_details_inside card_text_center" *ngIf="!diagramInfo.isDiagramsAdded">
        <div class="code_details_section">
            <h3>{{ 'STANDARD_FLANGE_PAGE.LABELS.SELECT_CODE_CONFIG' | transloco }}</h3>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.flange">
        <!-- <h3 class="mb-5">{{diagramInfo?.flange.diagramType}}</h3> -->
        <h3 class="mb-5">{{ 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAM_INPUT.FLANGE' | transloco }}</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramId]="diagramInfo?.flange?.diagramId"> </app-diagram-image>
                </div>
                <div class="col-md-6 middile_align" *ngIf="diagramInfo?.flange?.diagramId != null">
                    <app-diagram-flange-overrides
                        [isRedirect]="isRedirect"
                        [diagramInfo]="diagramInfo?.flange"
                        [isEditable]="diagramInfo?.isEditable"
                        (CalcOverrides)="diagramControlDataHandler($event)"
                        (diagram)="diagramDataHandler($event)"
                        style="width: 100%"
                        [calculationType]="calculationType"
                        (DiagramFormData)="DiagramFormDataHandler($event)"
                    ></app-diagram-flange-overrides>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.flangeFacing">
        <h3 class="mb-5">{{ 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAM_INPUT.FLANGE_FACING' | transloco }}</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramId]="diagramInfo?.flangeFacing?.diagramId"></app-diagram-image>
                </div>
                <div class="col-md-6 middile_align" *ngIf="diagramInfo?.flangeFacing?.diagramId != null">
                    <app-diagram-flange-facing-overrides
                        [isRedirect]="isRedirect"
                        [diagramInfo]="diagramInfo?.flangeFacing"
                        [isEditable]="diagramInfo?.isEditable"
                        (CalcOverrides)="diagramControlDataHandler($event)"
                        (ringNumber)="ringNumberDataHandler($event)"
                        style="width: 100%"
                        [calculationType]="calculationType"
                        (DiagramFormData)="DiagramFormDataHandler($event)"
                    ></app-diagram-flange-facing-overrides>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.gasket">
        <h3 class="mb-5">{{ 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAM_INPUT.GASKET' | transloco }}</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramId]="diagramInfo?.gasket?.diagramId"></app-diagram-image>
                </div>
                <div class="col-md-6 middile_align" *ngIf="diagramInfo?.gasket?.diagramId != null">
                    <app-diagram-gasket-overrides
                        [isRedirect]="isRedirect"
                        [diagramInfo]="diagramInfo?.gasket"
                        [isEditable]="diagramInfo?.isEditable"
                        [ringNumber]="ringNumber"
                        (CalcOverrides)="diagramControlDataHandler($event)"
                        style="width: 100%"
                        [calculationType]="calculationType"
                        (DiagramFormData)="DiagramFormDataHandler($event)"
                    ></app-diagram-gasket-overrides>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.boltSettingsName != null">
        <h3 class="mb-5">Bolt Settings</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramName]="diagramInfo?.boltSettingsName"></app-diagram-image>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.torqueSequenceName != null">
        <h3 class="mb-5">{{ 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAM_INPUT.TORQUE_SEQUENCE' | transloco }}</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramName]="diagramInfo?.torqueSequenceName"></app-diagram-image>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.clamp?.pipesizeId != null">
        <h3 class="mb-5">{{ 'CLAMP_PAGE.LABELS.CALC_INPUT.CLAMP' | transloco }}</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramId]="diagramInfo?.clamp.diagramId" [diagramName]="diagramInfo?.clamp.diagramType"></app-diagram-image>
                </div>
                <div class="col-md-6 middile_align">
                    <app-diagram-dimensions [diagramInfo]="diagramInfo?.clamp"></app-diagram-dimensions>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.engineeredJoint != null">
        <h3 class="mb-5">{{ 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT.ENGINEERED_JOINT' | transloco }}</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramId]="diagramInfo?.engineeredJoint.diagramId"></app-diagram-image>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.toolImage != null">
        <h3 class="mb-5">{{ diagramInfo?.toolImage.diagramType }}</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramId]="diagramInfo?.toolImage.diagramId"></app-diagram-image>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 mb-7" *ngIf="diagramInfo?.tool != null">
        <h3 class="mb-5">{{ diagramInfo?.tool.diagramType }}</h3>
        <div class="card card-custom pt-5 pb-5">
            <div class="row" style="width: 100%">
                <div class="col-md-6">
                    <app-diagram-image [diagramId]="diagramInfo?.tool.diagramId" (diagramData)="diagramDataResponseHandler($event)"></app-diagram-image>
                </div>
                <div class="col-md-6">
                    <app-tools-diamension [calcOutput]="calcOutput" [diagramResponse]="diagramResponse"></app-tools-diamension>
                </div>
            </div>
        </div>
    </div>
</div>
